export function getQueryParameter(parameter: string): string | null {
    let pattern = new RegExp(`(^|&)${parameter}=([^&]*)(&|$)`, "i")
    let matchs = window.location.search.substring(1).match(pattern)
    if (matchs != null) {
        return decodeURIComponent(matchs[2])
    } else {
        return null
    }
}

export function isTrial(): boolean {
    return getQueryParameter("trial") === "true";
}

export default { getQueryParameter, isTrial }
